<script lang="ts">
	//Design system components
	import { Radio } from '@Shelly/shelly-design-system';
	//Services
	import { format } from 'svelte-i18n';

	export let onetime, callback;
</script>

<Radio class="mb-s" size="m" selected={onetime} value={true} on:click={callback} id="radio-v1xrqyv"
	>{$format('settings_actions_one_time', {
		default: 'One time',
	})}</Radio
>
<Radio size="m" selected={!onetime} value={true} on:click={callback} id="radio-cu4514f"
	>{$format('settings_actions_repeatedly', {
		default: 'Repeatedly',
	})}</Radio
>
